import _throttle from 'lodash/throttle';

function vhNormalizer() {
  let lastVh;

  const normalize = () => {
    const vh = window.innerHeight * 0.01;

    if (vh === lastVh) return;

    lastVh = vh;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  normalize();
  window.addEventListener('resize', _throttle(() => normalize(), 1000));
}

export default vhNormalizer();
